// extracted by mini-css-extract-plugin
module.exports = {"box":"input_box__Alseb","textLabel":"input_textLabel__2JGte","inputGroup":"input_inputGroup__2-6FC","input":"input_input__3Fxtu"};